import { render, staticRenderFns } from "./ChapterNav.vue?vue&type=template&id=24f8677c&"
import script from "./ChapterNav.vue?vue&type=script&lang=js&"
export * from "./ChapterNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChapterNav.vue"
export default component.exports